/*
 * Homepage "All products": format tabs + "Load more", 12 cards at a time.
 * Pages come from /collections/<handle>?view=grid&page=N (bare card markup, no layout).
 */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const grid = root.querySelector('[data-ap-grid]');
    const more = root.querySelector('[data-ap-more]');
    const all = root.querySelector('[data-ap-all]');
    const status = root.querySelector('[data-ap-status]');
    const bar = root.querySelector('[data-ap-bar]');
    const tabs = [...root.querySelectorAll('[data-ap-tab]')];
    const tmpl = root.dataset.statusTemplate;
    const allTmpl = root.dataset.viewAllTemplate;
    let active = tabs.find(t => t.classList.contains('is-active')) || tabs[0];
    let page = 1, pages = Math.ceil((+active?.dataset.total || 0) / (+root.dataset.perPage || 12)), total = +active?.dataset.total || 0;
    let controller;

    const shown = () => grid.querySelectorAll('.card').length;
    function sync() {
      const n = shown();
      status.textContent = tmpl.replace('__shown__', n).replace('__total__', total);
      if (bar) bar.style.width = (total ? Math.max(1, Math.round(n / total * 100)) : 0) + '%';
      more.hidden = page >= pages || n >= total;
      all.href = active.dataset.url;
      all.textContent = allTmpl.replace('__count__', total);
    }

    async function load(tab, p, replace) {
      controller?.abort();
      controller = new AbortController();
      grid.setAttribute('aria-busy', 'true');
      more.disabled = true;
      root.classList.add('is-loading');
      try {
        const res = await fetch(`${tab.dataset.url}?view=grid&page=${p}`, { signal: controller.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const wrap = doc.querySelector('[data-ap-page]');
        if (!wrap) throw new Error('no grid');
        if (replace) grid.replaceChildren();
        grid.append(...wrap.children);
        page = +wrap.dataset.current; pages = +wrap.dataset.pages; total = +wrap.dataset.total;
        sync();
        if (!replace) grid.children[shown() - wrap.children.length]?.querySelector('a')?.focus({ preventScroll: true });
      } catch (e) {
        if (e.name !== 'AbortError') location.href = tab.dataset.url; // fall back to the collection page
      } finally {
        grid.setAttribute('aria-busy', 'false');
        more.disabled = false;
        root.classList.remove('is-loading');
      }
    }

    more.addEventListener('click', () => load(active, page + 1, false));
    tabs.forEach(tab => tab.addEventListener('click', () => {
      if (tab === active) return;
      tabs.forEach(t => { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-pressed', t === tab); });
      active = tab;
      tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      load(tab, 1, true);
    }));
    sync();
  }
  document.querySelectorAll('[data-all-products]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-all-products]').forEach(init));
})();
